import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, TableSortLabel, InputAdornment, LinearProgress, Slide, Slider, Snackbar, Table, TableBody, TableCell, TableContainer
  , TableHead, TableRow, TextField, Typography, Select, createMuiTheme, Paper, TableFooter
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import Tooltip from '@material-ui/core/Tooltip';
import BarcodeGenerator from 'src/components/BarcodeGenerator';
import SendIcon from '@material-ui/icons/Send';
import CropFreeIcon from '@material-ui/icons/CropFree';
import ScannerIcon from '@material-ui/icons/Scanner';
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import PrintIcon from '@material-ui/icons/Print';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import trLocale from 'date-fns/locale/tr';
import { getUser, sc } from 'src/utils/Common';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import MemoryIcon from '@material-ui/icons/Memory';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 800,
    minHeight: 800,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
  selectedRow: {
    backgroundColor: '#ecffde',
    // İlgili diğer stiller
  },
  redText: {
    backgroundColor: '#ffdfd4',
  },
  root1: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(1),
    margin: 'auto',
    maxWidth: '80%',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  field1: {
    marginBottom: theme.spacing(1),
  },
  table: {
    border: 'none',
    width: '100%'
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};
const customStyles = {
  overlay: {
    zIndex: 9999, // İstediğiniz z-indeksi burada ayarlayabilirsiniz
  },
  // Diğer stil ayarları burada tanımlanabilir
};

const entryListCells = [
  { id: 'UST_BIRIM_KODU', numeric: true, disablePadding: true, label: 'Bölge' },
  { id: 'KUL_BIRIM_KODU', numeric: true, disablePadding: true, label: 'ServisKodu' },
  { id: 'ACIKLAMA', numeric: false, disablePadding: true, label: 'Servis' },
  { id: 'CESIT', numeric: true, disablePadding: true, label: 'Çeşit' },
  { id: 'ALISKDVSIZ', numeric: true, disablePadding: true, label: 'StokTutar(Alış)' },
  { id: 'SATISKDVSIZ', numeric: true, disablePadding: true, label: 'StokTutar(Satış)' },
  { id: 'SIPARIS_FIS_ADET', numeric: true, disablePadding: true, label: 'FişAdet' },
];


function CustomerCare() {
  const classes = useStyles();
  const [TopServiceShopData, setTopServiceShopData] = useState([]);
  const [TopServiceShop, setTopServiceShop] = useState(null);
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [Data, setData] = useState([]);
  const [DataMain, setDataMain] = useState([]);
  const [ServiceShop, setServiceShop] = useState(null);
  const today = moment(new Date()).format('YYYY-MM-DD');

  const today1 = new Date();
  let lastWednesday = today1;

  while (lastWednesday.getDay() !== 3) {
    lastWednesday.setDate(lastWednesday.getDate() - 1);
  }
  const [StartDate, setStartDate] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [EndDate, setEndDate] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [sm, setSm] = useState({ entry: 6, exit: 3, return: 3 });
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [filtered, setFiltered] = useState({});
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');


  React.useEffect(() => {
    axios
      .get(`/GetTopServiceShop`)
      .then(response => {
        if (response.data.length > 0) {
          setTopServiceShopData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

  }, []);

  const handleTopServiceShopChange = e => {
    setTopServiceShop(e.target.value);
  };
  const getServiceShop = (UST_BIRIM_KODU) => {
    axios
      .get(`/GetServiceShop/` + UST_BIRIM_KODU)
      .then(response => {
        if (response.data.length > 0) {
          setServiceShopData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setStartDate(Deger) : setEndDate(Deger);
  };
  function onSearch() {
    setLoading(true);
    axios
      .get(
        `/GetCustomerCareOasis/${SessionUser.OrganizationUserId}/${TopServiceShop?.BOLGE_KODU}/${ServiceShop?.BIRIM_KODU}/${StartDate}/${EndDate}`
      )
      .then(response => {
        setLoading(false);
        setData(response.data);
        setDataMain(response.data);
      })
      .catch(error => {
        setLoading(false);
        setData([]);
        setDataMain([]);
      });
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  
  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell padding='none'
              key={headCell.id}
              align={'center'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardActions>
            <Autocomplete
              value={TopServiceShop}
              fullWidth
              size='small'
              onChange={(event, newValue) => {
                setTopServiceShop(newValue);
                getServiceShop(newValue.BOLGE_KODU);
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              options={TopServiceShopData}
              getOptionLabel={(option) => {
                if (typeof option === 'string') {
                  return option;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }
                return option.KUL_BOLGE_KODU + '-' + option.ACIKLAMA;
              }}
              renderOption={(option) => option.KUL_BOLGE_KODU + '-' + option.ACIKLAMA}
              freeSolo
              renderInput={(params) => (
                <TextField {...params} label="Bölge" variant="outlined" />
              )}
            />
            <Autocomplete
              value={ServiceShop}
              fullWidth
              onChange={(event, newValue) => {
                setServiceShop(newValue);
              }}
              selectOnFocus
              clearOnBlur
              size='small'
              handleHomeEndKeys
              options={ServiceShopData}
              getOptionLabel={(option) => {
                if (typeof option === 'string') {
                  return option;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }
                return option.KUL_BIRIM_KODU + '-' + option.ACIKLAMA;
              }}
              renderOption={(option) => option.KUL_BIRIM_KODU + '-' + option.ACIKLAMA}
              freeSolo
              renderInput={(params) => (
                <TextField {...params} label="Servis" variant="outlined" />
              )}
            />
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap['tr']}
              >
                <KeyboardDatePicker
                  color="primary"
                  fullWidth
                  size='small'
                  inputVariant="outlined"
                  invalidDateMessage={'Hatalı Tarih Formatı'}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={StartDate}
                  onChange={e => handleDateChange(e, 1)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap['tr']}>
                <KeyboardDatePicker
                  color="primary"
                  fullWidth
                  size='small'
                  inputVariant="outlined"
                  invalidDateMessage={'Hatalı Tarih Formatı'}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={EndDate}
                  onChange={e => handleDateChange(e, 2)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              size="medium"
              endIcon={<SearchIcon></SearchIcon>}
              onClick={onSearch}
            >
              Sorgula
            </Button>
          </CardActions>
          <Divider />
          <Grid container spacing={1}>
            <Grid xs={12} sm={sm.entry} style={{ paddingRight: '10px' }}>
              <Card spacing={2}>
                <CardHeader title="İşlemler" className={classes.cardHeader}
                  action={sm.entry === 6 ?
                    <RemoveIcon onClick={() => sm.entry === 6 ? setSm({ entry: 6, exit: 3, return: 3 }) : setSm({ entry: 6, exit: 3, return: 3 })} />
                    :
                    <AddIcon onClick={() => sm.entry === 6 ? setSm({ entry: 6, exit: 3, return: 3 }) : setSm({ entry: 6, exit: 3, return: 3 })} />
                  }
                />
                <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                  <Table
                    stickyHeader
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={'small'}>
                    <EnhancedTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      Header={entryListCells}
                    />
                    <TableBody>
                      {stableSort(Data || [], getComparator(order, orderBy))
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell padding='none' align="center" className={classes.tableCell}>
                              {row.UST_BIRIM_KODU}
                            </TableCell>
                            <TableCell padding='none' align="center" className={classes.tableCell}>
                              {row.KUL_BIRIM_KODU}
                            </TableCell>
                            <TableCell padding='none' align="left" className={classes.tableCell}>
                              {row.ACIKLAMA}
                            </TableCell>
                            <TableCell padding='none' align="right" className={classes.tableCell}>
                              {row.CESIT}
                            </TableCell>
                            <TableCell padding='none' align="right" className={classes.tableCell}>
                              {row.ALISKDVSIZ}
                            </TableCell>
                            <TableCell padding='none' align="right" className={classes.tableCell}>
                              {row.SATISKDVSIZ}
                            </TableCell>
                            <TableCell padding='none' align="right" className={classes.tableCell}>
                              {row.SIPARIS_FIS_ADET}
                            </TableCell>

                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid xs={12} sm={sm.exit} style={{ paddingRight: '10px' }}>
              <Card spacing={2}>
                <CardHeader title="Grafikler" className={classes.cardHeader}
                  action={sm.exit === 6 ?
                    <RemoveIcon onClick={() => sm.exit === 6 ? setSm({ entry: 3, exit: 6, return: 3 }) : setSm({ entry: 3, exit: 6, return: 3 })} />
                    :
                    <AddIcon onClick={() => sm.exit === 6 ? setSm({ entry: 3, exit: 6, return: 3 }) : setSm({ entry: 3, exit: 6, return: 3 })} />
                  }
                />
              </Card>
            </Grid>
            <Grid xs={12} sm={sm.return}>
              <Card spacing={2}>
                <CardHeader title="Malzeme Nerede?" className={classes.cardHeader}
                  action={sm.return === 6 ?
                    <RemoveIcon onClick={() => sm.return === 6 ? setSm({ entry: 3, exit: 3, return: 6 }) : setSm({ entry: 3, exit: 3, return: 6 })} />
                    :
                    <AddIcon onClick={() => sm.return === 6 ? setSm({ entry: 3, exit: 3, return: 6 }) : setSm({ entry: 3, exit: 3, return: 6 })} />
                  }
                />
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Page>
  );
}

export default CustomerCare;
